import AOS from "aos";
import "aos/dist/aos.css";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./home.scss";

function Home() {
	AOS.init({
		delay: 500,
		once: true
	});

	return (
		<div className="sec5">
			<div className="container">
				<div className="awards">
					<div className="col-md-7 col-md-4 row hidetab"></div>
					<div className="sec5Head col-lg-5 col-md-8">
						<h6
							className="small-title"
							data-aos="fade-up"
							data-aos-anchor-placement="bottom-bottom"
						>
							WHAT WE HAVE
						</h6>
						<h6 className="title" data-aos="">
						Your Trusted Partner for Jewelry Appraisal						</h6>
						<p data-aos="" className="assesmentText">
						At GGILab, we offer expert jewelry appraisal services. Our skilled gemologists accurately assess the value of your precious jewelry, including diamonds, colored gemstones, and fine metal pieces. Whether you need an appraisal for insurance, estate planning, or resale, we provide comprehensive and reliable valuations. Trust GGILab for all your jewelry appraisal needs.

						</p>
						{/* <div className='progressDiv'>
							<div className='progressName'>
								<h6>World Wide Certification</h6>
								<h6>100%</h6>
							</div>
							<div className='progressArea'>
								<div className='progressBar' style={{ width: progress }}></div>
							</div>
						</div>
						<div className='progressDiv'>
							<div className='progressName'>
								<h6>Latest Equipment And Machines</h6>
								<h6>90%</h6>
							</div>
							<div className='progressArea'>
								<div className='progressBar' style={{ width: machines }}></div>
							</div>
					</div> */}
					</div>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
